import { useMutation } from '@apollo/client';
import { CartType } from 'graphql-ts-types';

import cookieStorage from '../../CookieStorage';
import type {
  ReevaluateCartDiscountsMutation,
  ReevaluateCartDiscountsMutationVariables,
} from '../../gql/generated/schema';
import { reevaluateCartDiscountsMutation } from '../../gql/mutation/cart/reevaluate-cart-discounts';
import { useGQLLocale } from '../locale';

export const useReevaluateCartDiscounts = () => {
  const locale = useGQLLocale();

  const [reevaluateDiscounts] = useMutation<
    ReevaluateCartDiscountsMutation,
    ReevaluateCartDiscountsMutationVariables
  >(reevaluateCartDiscountsMutation);

  return () =>
    reevaluateDiscounts({
      variables: {
        locale,
        cartType: CartType.Default,
        zipCode: cookieStorage.getZipCode(),
      },
    });
};
